export default function DS_Linear_Regression() {
  return <div>DS_Linear_Regression Component</div>;
}
